import { Variant } from "@mui/material/styles/createTypography";
import { FieldEditorRender } from "./Renders/FieldEditorRender";


export default class EasyFormColumn {
    description?: string
    title?: string
    titleVariant?: Variant
    fieldEditorRenders?: FieldEditorRender[]
    constructor(title: string, description: string, fieldEditorRenders: FieldEditorRender[], titleVariant?: Variant) {
        this.title = title;
        this.description = description;
        this.fieldEditorRenders = fieldEditorRenders
        this.titleVariant = titleVariant
    }
}